// extracted by mini-css-extract-plugin
module.exports = {"chatContainer":"ZohoChat_chatContainer__1NlOC","icon":"ZohoChat_icon__3s5DF","chatButton":"ZohoChat_chatButton__27UmX"};